export const VALID_CURRENCIES = ['usd', 'cad', 'gbp', 'aud', 'zar', 'eur']
export const CURRENCY_SYMBOLS = {
  usd: '$',
  cad: '$',
  aud: '$',
  gbp: '£',
  zar: 'R',
  eur: '€',
}
